<template>
  <div class="bg-[#FFFFFF]">
    <div
      class="w-100 bg-[#F8F8F8] border border-2 px-1 py-[1.2rem] rounded-t-xl font-semibold text-black"
    >
      Ringkasan Info
    </div>
    <div class="p-1 border border-2 rounded-b-xl text-black h-[10rem] overflow-auto">
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Nama Bisnis
        </BCol>
        <BCol
          cols="7"
          class="text-black font-semibold"
        >
          : {{ ["", null].includes(brandName) ? "-" : brandName }}
        </BCol>
      </BRow>
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Saldo Terupdate
        </BCol>
        <BCol
          cols="7"
          class="font-semibold d-flex"
        >
          <div class="align-self-center">
            <span>: </span>
            <span class="text-[#F95031]">{{ IDR(kmpoin) }}</span>
          </div>
          <span v-if="financeMenu.topupMenu">
            <span
              id="private-btn"
              class="k-money-change ml-1 text-primary text-3xl cursor-pointer"
            />
            <b-popover
              target="private-btn"
              triggers="click"
              placement="right"
              custom-class="w-64"
            >
              <button
                class="btn"
                @click="setActionModal('Top Up Saldo')"
              >
                Top Up Saldo
              </button>
              <button
                class="btn"
                @click="setActionModal('Pengurangan Saldo')"
              >
                Pengurangan Saldo
              </button>
              <button
                class="btn"
                :disabled="financeMenu.transferSaldo"
                @click="setActionModal('Transfer Saldo')"
              >
                Transfer Saldo
              </button>
            </b-popover>
          </span>
        </BCol>
      </BRow>
    </div>
    <ModalPrivate :modal-value="modalValue" />
    <ModalPin
      :modal-value="modalValue"
      @update-user-data="$emit('update-user-data')"
    />
  </div>
</template>

<style scoped>
@media screen and (min-width: 1280px) {
  .text-truncate {
    max-width: 280px;
  }
}
</style>

<script>
import { IDR } from '@/libs/currency'
import ModalPrivate from './ModalPrivate.vue'
import ModalPin from './ModalPIN.vue'

export default {
  components: {
    ModalPrivate,
    ModalPin,
  },
  props: {
    brandName: {
      type: String,
      default: null,
    },
    kmpoin: {
      type: Number,
      default: 0,
    },
    financeMenu: {
      type: Object,
      default: () => ({
        topupMenu: false,
        transferSaldo: false,
      }),
    },
    modalValue: {
      type: Object,
      default: () => {},
    },
    getDetail: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      IDR,
    }
  },
  methods: {
    setActionModal(value) {
      this.$root.$emit('bv::hide::popover', 'private-btn')
      this.modalValue.titleModal = value
      this.modalValue.subTitle = value
      if (this.modalValue.titleModal === 'Top Up Saldo') {
        this.modalValue.type = 'TopupManual'
        this.modalValue.placeholderNotes = 'Top up Rp xx.xxx untuk keperluan ganti rugi paket hilang/rusak'
        this.$bvModal.show('modal-private-action')
      } else if (this.modalValue.titleModal === 'Pengurangan Saldo') {
        this.modalValue.type = 'BalanceReduction'
        this.modalValue.placeholderNotes = 'Pengurangan saldo sebesar Rp xx.xxx untuk transaksi xyz'
        this.$bvModal.show('modal-private-action')
      } else if (
        this.modalValue.titleModal === 'Transfer Saldo'
        && !this.financeMenu.transferSaldo
      ) {
        this.modalValue.subTitle = 'Pengurangan Saldo'
        this.modalValue.type = 'TransferSaldo'
        this.modalValue.emailRequired = true
        this.modalValue.placeholderNotes = 'Pemindahan dana Rp xx.xxx dari putri1@gmail.com ke putri2@gmail.com'
        this.modalValue.email = ''
        this.$bvModal.show('modal-private-action')
      }
      this.modalValue.kmpoin = this.kmpoin
    },
  },
}
</script>
